import { styled } from "@styles";
import { Accordion, Card, InputGroup, Row } from "react-bootstrap";

export const Wrapper = styled(Accordion)``;

export const CheckoutDiscountCard = styled(Card)``;

export const CheckoutDiscountCardHeader = styled(Card.Header)`
  text-align: center;
`;

export const CheckoutDiscountCardHeaderTitle = styled(Accordion.Toggle)`
  font-weight: 700;
  text-transform: uppercase;
`;

export const CheckoutDiscountCardCollapse = styled(Accordion.Collapse)``;

export const CheckoutDiscountCardBody = styled(Card.Body)``;

export const FormLabel = styled.label`
  padding-top: calc(.375rem + 1px);
  padding-bottom: calc(.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
`;

export const InputGroupRow = styled(Row)`
  margin-bottom: 1rem
`;

export const InputGroupStyle = styled(InputGroup)``;

export const InputGroupStylePrepend = styled(InputGroup.Prepend)`
  width: 100%;
`;

export const PointGuideWrapper = styled.p`
  margin-bottom: 0;
`;

export const PointGuideText = styled.small`
  color: #aaa;
  border-radius: 0;
`;

export const VoucherGuideWrapper = styled.p`
  margin-bottom: 0;
`;

export const VoucherGuideText = styled.a`
  color: #aaa;
  border-radius: 0;
  font-size: 80%;
`;

export const CODPointNotAvailableWrapper = styled.p`
  margin-bottom: 0;
`;

export const CODPointNotAvailableText = styled.small`
  color: #FF3399;
  border-radius: 0;
`;